import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LoginForm from '../components/LoginForm.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LoginForm))
}
}

})